import { LOCAL_STORAGE_KEYS } from '@/app/common/local-storage'
import { useMutation } from '@tanstack/react-query'
import { GETInitiateIdentityVerification, GETVerifyIdentity } from './requests'

type SubmitVerificationParams = {
  token: string
  programId: number
}

function useIdentityVerification() {
  const initiateIdentityVerification = useMutation({
    onSuccess: (data) => {
      setTimeout(() => {
        localStorage.setItem(LOCAL_STORAGE_KEYS.clearme_id, data.id)          
      }, 100);
      window.location.href = `https://verified.clearme.com/verify?token=${data.token}`
    },
    mutationFn: GETInitiateIdentityVerification,
  })

  const submitVerification = useMutation({
    mutationFn: ({ token, programId }: SubmitVerificationParams) =>
      GETVerifyIdentity(token, programId),
  })

  return {
    initiateIdentityVerification,
    submitVerification,
  }
}

export default useIdentityVerification
